<template>
  <b-modal
    v-model="modal.show"
    title="Choose Table For the Panel"
    size="xl"
    :ok-disabled="disableButton"
    @show="onModalShow"
    @shown="computedLinkedTables"
    @ok.prevent="onSubmit"
    @hidden="onHide"
  >
    <content-spinner :show="loading" />
    <b-form-checkbox
      v-if="!loading && !isStartingPoint"
      v-model="isLinkedTable"
      switch
      class="mb-2"
      @change="onLinkedTableCLick"
    >
      <b>Linked Tables</b>
    </b-form-checkbox>
    <div
      v-if="!loading"
      class="row"
    >
      <div
        v-for="(data, indexName) in modalData"
        class="mt-2"
        :class="columnClass"
      >
        <b-list-group class="table-list-group">
          <b-list-group-item>
            <b-form-input
              v-model="searchKeyword[indexName]"
              :placeholder="`Filter ${indexName}s`"
              type="text"
            />
          </b-list-group-item>
          <b-list-group-item
            v-for="item of data"
            :active="item.isActiveItem"
            @click="onItemClick(item, indexName)"
          >
            {{ item.displayName || item.folderName || item.moduleName }}
          </b-list-group-item>
          <no-content
            :show="Object.keys(data).length === 0"
            :text="`Unable to find ${indexName}s`"
          />
        </b-list-group>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import NoContent from '../NoContent';
import ContentSpinner from '../ContentSpinner';

const {mapState, mapActions} = createNamespacedHelpers('dataManagement');
export default {
  name: 'DataManagementModal',
  components: {ContentSpinner, NoContent},
  props: {
    isStartingPoint: {
      type: Boolean,
      default: false,
    },
    selectedField: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      moduleData: {},
      tableFields: [],
      selectedOption: {},
      searchKeyword: {},
      modalData: {},
      isLinkedTable: false,
      uniqueEntityGuid: [],
      uniqueFolderGuid: [],
      uniqueModuleGuid: [],
    };
  },
  watch: {
    ['searchKeyword.Module']() {
      this.modalFilteredData();
    },
    ['searchKeyword.Folder']() {
      this.modalFilteredData();
    },
    ['searchKeyword.Table']() {
      this.modalFilteredData();
    },
    ['searchKeyword.Field']() {
      this.modalFilteredData();
    },
  },
  computed: {
    ...mapState({
      modal: state => state.dataManagementModal,
    }),
    ...mapState(['permissionTypes', 'modules', 'allFolders', 'tables', 'fields']),
    columnClass() {
      return this.isStartingPoint ? 'col-3' : 'col-4';
    },
    disableButton() {
      return this.isStartingPoint ? !this.selectedOption.fieldGuid || this.selectedOption.isActiveItem :
        !this.selectedOption.entityGuid || this.selectedOption.isActiveItem;
    },
  },
  methods: {
    ...mapActions(['hideDataManagementModal', 'getModules', 'getAllFolder', 'getTables', 'getFields']),
    onSubmit() {
      const params = {
        ...this.selectedOption,
        type: 'table',
      };
      if (this.isStartingPoint) {
        this.$emit('on-submit', this.selectedOption);
      } else {
        this.$emit('on-table-panel-submit', params, true);
      }
      this.onHide();
    },
    onHide() {
      this.hideDataManagementModal();
      this.clearData();
      this.$emit('on-table-panel-close');
    },
    clearData() {
      this.modalData = JSON.parse(JSON.stringify({...this.moduleData}));
      this.selectedOption = {};
      this.searchKeyword = {};
      this.isLinkedTable = false;
    },
    onItemClick(item, type) {
      this.selectedOption = item;
      let modalData = JSON.parse(JSON.stringify({...this.moduleData}));

      // Filter folders and tables data after select module and active module or folder after select table or folder

      modalData['Folder'] = modalData['Folder'].filter(f => item.moduleGuid === f.moduleGuid);
      modalData['Table'] = modalData['Table'].filter(t => this.isModule(type) ? item.moduleGuid === t.moduleGuid : item.folderGuid === t.folderGuid);

      if (this.isStartingPoint) {
        modalData['Field'] = modalData['Field'].filter(f => this.isModule(type) ? item.moduleGuid === f.moduleGuid :
          this.isFolder(type) ? item.folderGuid === f.folderGuid : item.entityGuid === f.entityGuid);
      }

      modalData['Module'].map(data => {
        if (data.moduleGuid === item.moduleGuid) {
          data.isActiveItem = this.isModule(type) ? !this.selectedOption.isActiveItem : true;
          if (!data.isActiveItem) {
            modalData = JSON.parse(JSON.stringify({...this.moduleData}));
          }
        }
        return data;
      });

      if (this.isFolder(type) || this.isTable(type) || this.isField(type)) {
        modalData['Folder'].map(data => {
          if (data.folderGuid === item.folderGuid) {
            data.isActiveItem = this.isFolder(type) ? !this.selectedOption.isActiveItem : true;
            if (this.isFolder(type) && !data.isActiveItem) {
              modalData['Table'] = this.moduleData['Table'].filter(t => item.moduleGuid === t.moduleGuid);
              if (this.isStartingPoint) {
                modalData['Field'] = this.moduleData['Field'].filter(f => item.moduleGuid === f.moduleGuid);
              }
            }
          }
          return data;
        });
      }

      if (this.isTable(type) || this.isField(type)) {
        modalData['Table'].map(data => {
          if (data.entityGuid === item.entityGuid) {
            data.isActiveItem = this.isTable(type) ? !this.selectedOption.isActiveItem : true;
            if (this.isTable(type) && !data.isActiveItem && this.isStartingPoint) {
              modalData['Field'] = this.moduleData['Field'].filter(f => f.folderGuid === item.folderGuid);
            }
          }
          return data;
        });
      }

      if (this.isField(type) && this.isStartingPoint) {
        modalData['Field'].map(data => {
          if (data.fieldGuid === item.fieldGuid) {
            data.isActiveItem = !this.selectedOption.isActiveItem;
          }
          return data;
        });
      }

      this.modalData = {...modalData};

      if (this.isLinkedTable) {
        this.filterByLinkedTable();
      }

      if (Object.keys(this.searchKeyword).length > 0) {
        this.modalFilteredData(true);
      }
    },
    modalFilteredData(isModified = false) {
      if (!isModified) {
        this.selectedOption = {};
      }
      const modalData = Object.keys(this.selectedOption).length > 0 ?
        {...this.modalData} : JSON.parse(JSON.stringify({...this.moduleData}));

      if (Object.keys(this.searchKeyword).length > 0) {
        for (const keyword in this.searchKeyword) {
          if (this.searchKeyword.hasOwnProperty(keyword)) {
            modalData[keyword] = modalData[keyword].filter(data => {
              const name = data.displayName || data.folderName || data.moduleName;
              return name.toLowerCase().includes(this.searchKeyword[keyword].toLowerCase());
            });

            // Filter folder and table automatically after filter module
            if (this.isModule(keyword)) {
              const moduleIds = modalData[keyword].map(data => data.moduleGuid);

              modalData['Folder'] = modalData['Folder'].filter(data => moduleIds.includes(data.moduleGuid));
              modalData['Table'] = modalData['Table'].filter(data => moduleIds.includes(data.moduleGuid));
            }

            // Filter table automatically after filter folder
            if (this.isFolder(keyword)) {
              const folderIds = modalData[keyword].map(data => data.folderGuid);

              modalData['Table'] = modalData['Table'].filter(data => folderIds.includes(data.folderGuid));
            }

            if (this.isStartingPoint && !this.isField(keyword)) {
              const filterTableGuids = modalData['Table'].map(t => t.entityGuid);
              modalData['Field'] = modalData['Field'].filter(data => filterTableGuids.includes(data.entityGuid));
            }
          }
        }
      }

      this.modalData = {...modalData};

      if (this.isLinkedTable) {
        this.filterByLinkedTable();
      }
    },
    onLinkedTableCLick() {
      this.$nextTick(() => {
        this.modalFilteredData();
        if (this.isLinkedTable) {
          this.filterByLinkedTable();
        }
      });
    },
    computedLinkedTables() {
      this.modalData = JSON.parse(JSON.stringify({...this.moduleData}));

      // Calculate tables of current models related tables
      const currentModuleTableIds = this.modalData['Table'].filter(t => t.moduleGuid === this.$route.params.moduleUuid).map(t => t.entityGuid);
      const currentTableFields = this.tableFields.filter(f => currentModuleTableIds.includes(f.entityGuid)).map(f => f.fieldGuid);
      const linkedTablesLookupFields = this.tableFields.filter(f => this.isFieldLookup(f) && currentTableFields.includes(JSON.parse(f.dataTypeJSON).FieldToDisplayGuid));

      linkedTablesLookupFields.forEach(field => {
        if (!this.uniqueEntityGuid.includes(field.entityGuid)) {
          this.uniqueEntityGuid.push(field.entityGuid);
        }
      });
      this.modalData['Table'].forEach(data => {
        if (this.uniqueEntityGuid.includes(data.entityGuid) && !this.uniqueFolderGuid.includes(data.folderGuid)) {
          this.uniqueFolderGuid.push(data.folderGuid);
        }
      });
      this.modalData['Folder'].forEach(data => {
        if (this.uniqueFolderGuid.includes(data.folderGuid) && !this.uniqueModuleGuid.includes(data.moduleGuid)) {
          this.uniqueModuleGuid.push(data.moduleGuid);
        }
      });

      if (this.isStartingPoint && Object.keys(this.selectedField).length > 0) {
        this.onItemClick(this.selectedField, 'Field');
      }

      this.$nextTick(() => {
        this.loading = false;
      });
    },
    onModalShow() {
      this.loading = true;
    },
    filterByLinkedTable() {
      this.modalData['Module'] = this.modalData['Module'].filter(data => this.uniqueModuleGuid.includes(data.moduleGuid));
      this.modalData['Folder'] = this.modalData['Folder'].filter(data => this.uniqueFolderGuid.includes(data.folderGuid));
      this.modalData['Table'] = this.modalData['Table'].filter(data => this.uniqueEntityGuid.includes(data.entityGuid));
    },
    isModule(type) {
      return type === 'Module';
    },
    isFolder(type) {
      return type === 'Folder';
    },
    isTable(type) {
      return type === 'Table';
    },
    isField(type) {
      return type === 'Field';
    },
    isFieldLookup(field) {
      const type = field.type || field.dataTypeName;
      return type === 'lookup';
    },
  },
  async mounted() {
    await this.getModules();
    this.moduleData = {
      ...this.moduleData,
      Module: this.modules.data.filter(m => ![this.permissionTypes.none, this.permissionTypes.deny].includes(m.currentUserPermissionLevel)),
    };
    await this.getAllFolder();
    this.moduleData = {
      ...this.moduleData,
      Folder: this.allFolders.filter(f => ![this.permissionTypes.none, this.permissionTypes.deny].includes(f.currentUserPermissionLevel)),
    };
    await this.getTables();
    this.moduleData = {
      ...this.moduleData,
      Table: this.tables.data.filter(t => ![this.permissionTypes.none, this.permissionTypes.deny].includes(t.currentUserPermissionLevel)),
    };
    await this.getFields();
    this.tableFields = [...this.fields.data];
    if (this.isStartingPoint) {
      this.moduleData = {
        ...this.moduleData,
        Field: this.tableFields.filter(f => ![this.permissionTypes.none, this.permissionTypes.deny].includes(f.currentUserPermissionLevel) && !f.isInternal),
      };
      this.moduleData['Field'].map(f => {
        const table = this.moduleData['Table'].find(t => t.entityGuid === f.entityGuid);
        if (table) {
          f.folderGuid = table.folderGuid;
          f.moduleGuid = table.moduleGuid;
        }
        return f;
      });
    }
  },
};
</script>

<style scoped lang="scss">
.table-list-group {
  min-height: 600px;
  max-height: 600px;
  overflow: auto;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.list-group-item {
  border-left: none;
  border-right: none;
  padding: 0.5rem 0.5rem;
}
</style>